(ns manage.ad-variant.data
  "For ad-variant-page and preview"
  (:require ["src/svg/type/ad_format/meta-carousel.svg$default" :as MetaCarousel]
            ["src/svg/type/ad_format/meta-single-image.svg$default" :as MetaSingleImage]
            ["src/svg/type/ad_format/meta-single-video.svg$default" :as MetaSingleVideo]
            ["src/svg/type/ad_format/youtube-bumper.svg$default" :as YoutubeBumper]
            ["src/svg/type/ad_format/youtube-non-skippable.svg$default" :as YoutubeNonSkippable]
            ["src/svg/type/ad_format/youtube-skippable.svg$default" :as YoutubeSkippable]
            ["src/svg/type/adset_channel/display.svg$default" :as DisplayIcon]
            ["src/svg/type/adset_channel/video.svg$default" :as VideoIcon]
            ["src/svg/type/thumbnails/meta-carousel.svg$default" :as MetaCarouselThumbnail]
            ["src/svg/type/thumbnails/meta-single-image.svg$default" :as MetaSingleImageThumbnail]
            ["src/svg/type/thumbnails/meta-single-video.svg$default" :as SingleVideoThumbnail]
            ["src/svg/type/thumbnails/youtube-bumper.svg$default" :as YouTubeBumperThumbnail]
            ["src/svg/type/thumbnails/youtube-non-skippable.svg$default" :as YouTubeNonSkippableThumbnail]
            ["src/svg/type/thumbnails/youtube-skippable.svg$default" :as YouTubeSkippableThumbnail]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.widgets.column-renderers :refer [template-duration-renderer]]
            [lemonpi.ads-schema.interface :as ads-schema]))

(def legacy->new-ad-type
  {"imageUri" "meta-single-image"
   "videoUri" "meta-single-video"
   "vast-aws-prime" "vast-linear"})

(defn normalize-ad-type [ad-type]
  (get legacy->new-ad-type ad-type ad-type))

(def amazon-stv-component-key :urn:lemonpi:vast:video:amazon-prime)

(def ad-types
  {"display-html" {:title "HTML5"
                   :ad-builder-urn "urn:ad-builders:lemonpi:display"
                   :get-main-component [:urn:lemonpi:artefact:display:content+template]
                   :icon DisplayIcon}
   "pass-through-display-html" {:title "HTML5"
                                :ad-builder-urn "urn:ad-builders:lemonpi:pass-through:display"
                                :get-main-component [:urn:lemonpi:artefact:display:content+template]
                                :icon DisplayIcon}
   "vast-linear" {:title "VAST"
                  :ad-builder-urn "urn:ad-builders:lemonpi:vast"
                  :get-main-component [:urn:lemonpi:vast:video:scale:full:kbps:4000
                                       :urn:lemonpi:vast:video-1
                                       amazon-stv-component-key]
                  :icon VideoIcon
                  :thumbnail SingleVideoThumbnail}
   "youtube-bumper" {:title "YouTube bumper"
                     :ad-builder-urn "urn:ad-builders:youtube:bumper"
                     :get-main-component [:urn:youtube:bumper-video]
                     :icon YoutubeBumper
                     :thumbnail YouTubeBumperThumbnail
                     :description "Short, non-skippable video ads of up to 6 seconds that must be watched before a video can be viewed."}
   "youtube-non-skippable" {:title "Non-skippable video"
                            :ad-builder-urn "urn:ad-builders:youtube:non-skippable"
                            :get-main-component [:urn:youtube:video]
                            :icon YoutubeNonSkippable
                            :thumbnail YouTubeNonSkippableThumbnail
                            :description "Non-skippable video ads must be watched before a video can be viewed."}
   "youtube-skippable" {:title "Skippable video"
                        :ad-builder-urn "urn:ad-builders:youtube:skippable"
                        :get-main-component [:urn:youtube:video]
                        :icon YoutubeSkippable
                        :thumbnail YouTubeSkippableThumbnail
                        :description "Skippable video ads allow viewers to skip ads after 5 seconds."}
   "meta-single-video" {:title "Single video"
                        :ad-builder-urn "urn:ad-builders:meta:single-video"
                        :get-main-component [:urn:meta:single-video :urn:meta:video]
                        :icon MetaSingleVideo
                        :thumbnail SingleVideoThumbnail
                        :description "An ad with one video"}
   "meta-single-image" {:title "Single image"
                        :ad-builder-urn "urn:ad-builders:meta:single-image"
                        :get-main-component [:urn:meta:single-image :urn:meta:image]
                        :icon MetaSingleImage
                        :thumbnail MetaSingleImageThumbnail
                        :description "Up to 6 ads with one image each"}
   "meta-pass-through-single-image" {:title "Pass Through Image"
                                     :ad-builder-urn "urn:ad-builders:meta:pass-through-single-image"
                                     :get-main-component [:urn:meta:single-image :urn:meta:image]
                                     :icon MetaSingleImage
                                     :thumbnail MetaSingleImageThumbnail
                                     :description "An ad with one image that skips rendering"}
   "meta-pass-through-single-video" {:title "Pass Through Video"
                                     :ad-builder-urn "urn:ad-builders:meta:pass-through-single-video"
                                     :get-main-component [:urn:meta:single-video :urn:meta:video]
                                     :icon MetaSingleVideo
                                     :thumbnail SingleVideoThumbnail
                                     :description "An ad with one video that skips rendering"}
   "meta-carousel" {:title "Carousel"
                    :ad-builder-urn "urn:ad-builders:meta:carousel"
                    :get-main-component [:urn:meta:carousel:cards]
                    :icon MetaCarousel
                    :thumbnail MetaCarouselThumbnail
                    :description "An ad with multiple scrollable cards"}
   "tiktok-single-video" {:title "Single video"
                          :ad-builder-urn "urn:ad-builders:tiktok:single-video"
                          :get-main-component [:urn:tiktok:single-video :urn:tiktok:video]
                          :icon MetaSingleVideo
                          :thumbnail SingleVideoThumbnail
                          :description "An ad with one video"}
   "tiktok-single-image" {:title "Single image"
                          :ad-builder-urn "urn:ad-builders:tiktok:single-image"
                          :get-main-component [:urn:tiktok:single-image :urn:tiktok:image]
                          :icon MetaSingleImage
                          :thumbnail MetaSingleImageThumbnail
                          :description "Up to 6 ads with one image each"}
   ;; On ad variant creation, ctv-avod will become vast-linear.
   "ctv-avod" {:title "AVOD"
               :description "Advertiser Video on Demand"
               :ad-builder-urn "urn:ad-builders:lemonpi:vast"
               :get-main-component [:urn:lemonpi:vast:video:scale:full:kbps:4000]
               :icon VideoIcon
               :thumbnail SingleVideoThumbnail}
   "ctv-uk-bvod" {:title "BVOD"
                  :description "Broadcast Video on Demand"
                  :ad-builder-urn "urn:ad-builders:ctv:uk:bvod"
                  :get-main-component [:urn:ctv:uk:bvod:finecast]
                  :icon VideoIcon
                  :thumbnail SingleVideoThumbnail}})

(defn adset->ad-types [adset]
  (case (:channel adset)
    "meta" (select-keys ad-types ["meta-single-image" "meta-single-video" "meta-carousel"])
    "tiktok" (select-keys ad-types ["tiktok-single-image" "tiktok-single-video"])
    "display" (select-keys ad-types ["display-html"])
    "youtube" (select-keys ad-types ["youtube-bumper" "youtube-skippable" "youtube-non-skippable"])
    "video" (select-keys ad-types ["vast-linear"])
    "ctv" (select-keys ad-types (if (= "gb" (first (:countries adset)))
                                  ["ctv-avod" "ctv-uk-bvod"]
                                  ["ctv-avod"]))
    {}))

(defn dynamic-creation-ad-types [adset]
  (let [adset-ad-types (adset->ad-types adset)]
    ;; TODO: WPPODC-12261 enable ad-builder for meta-carousel
    (dissoc adset-ad-types "meta-carousel")))

(defn meta? [ad-type]
  (contains? #{"meta-single-video" "meta-single-image" "meta-pass-through-single-video" "meta-pass-through-single-image" "meta-carousel"} ad-type))

(defn tiktok? [ad-type]
  (contains? #{"tiktok-single-video" "tiktok-single-image"} ad-type))

(defn carousel-has-video? [components]
  (some (fn [card]
          (some #(= "video" (:kind %)) (ads-schema/carousel-card-media-list card)))
        (:value (get components :urn:meta:carousel:cards))))

(defn get-component-type [ad-type]
  (case (normalize-ad-type ad-type)
    ("display-html"
     "pass-through-display-html") :html

    "meta-carousel" :carousel

    ("meta-single-image"
     "meta-pass-through-single-image"
     "tiktok-single-image") :image

    ("vast-linear"
     "meta-single-video"
     "meta-pass-through-single-video"
     "tiktok-single-video"
     "ctv-avod"
     "ctv-uk-bvod"
     "youtube-skippable"
     "youtube-non-skippable"
     "youtube-bumper") :video
    nil))

;; Used for "vast-linear" ad builders instead of the default urn, when the
;; "STV" format is picked in the ad-builder creation modal.
(def amazon-stv-ad-builder-urn "urn:ad-builders:amazon:prime:video")

(defn video-format->ad-builder-urn-override [video-format]
  (when (= video-format "stv") amazon-stv-ad-builder-urn))

;; The :placement a manually uploaded "vast-linear" ad needs for content-build's
;; video-transcoder to convert it into Amazon Prime Video's STV spec, instead of
;; creating the ad-variant from the uploaded file(s) as-is.
(def amazon-stv-placement "amazon-stv")

(def ad-builder-urn->ad-type
  (-> (reduce (fn [acc [k {:keys [ad-builder-urn]}]]
                (assoc acc ad-builder-urn k))
              {}
              (dissoc ad-types "ctv-avod"))
      ;; Amazon STV ads carry their own ad-type, normalized to vast-linear everywhere else.
      (assoc amazon-stv-ad-builder-urn "vast-aws-prime")))

(def status
  {"queued" {:title "Queued"
             :actions #{:cancel-render}}
   "canceled" {:title "Rendering canceled"
               :actions #{:render-again}}
   "rendering" {:title "Rendering"
                :actions #{:cancel-render}}
   "error" {:title "Failed"
            :color "error"
            :actions #{}}
   "render-failed" {:title "Render failed"
                    :color "error"
                    :actions #{:render-again :archive}}
   "unknown" {:title "Unknown"
              :color "error"
              :actions #{}}
   "draft" {:title "Draft"
            :actions #{:approve :reject :ready-and-update-dt}}
   "approved" {:title "Ready"
               :color "success"
               :actions #{:reject :ready-and-update-dt}}
   "rejected" {:title "Requires changes"
               :color "warning"
               :actions #{:approve :archive :ready-and-update-dt}}
   "archived" {:title "Archived"
               :actions #{:unarchive}}
   "internal-review" {:title "Internal review"
                      :actions #{:approve :reject :ready-and-update-dt}}})

(def status-filter-groups
  {"error" #{"error" "render-failed" "unknown" "canceled"}
   "processing" #{"queued" "rendering"}})

(def status-with-aggregates
  (merge status
         {"all-draft" {:title "All draft"}
          "all-approved" {:title "All approved"}
          "partially-approved" {:title "Partially approved"}}))

(def status-with-qc
  (-> status-with-aggregates
      (assoc-in ["approved" :actions] #{:internal-review :approve :archive :ready-and-update-dt})
      (assoc-in ["draft" :actions] #{:internal-review :approve :archive :ready-and-update-dt})
      (assoc-in ["rejected" :actions] #{:internal-review :approve :archive :ready-and-update-dt})))

(def status-review-mode
  (-> status-with-qc
      (update "internal-review" assoc :title "Add review" :color "primary")
      (assoc-in ["approved" :title] "Approved")))

(defn status->actions [status]
  (-> (get status-with-qc status)
      :actions))

(defn ad-type-title [ad-type]
  (:title (get ad-types (normalize-ad-type ad-type))))

(defn ad-builder-urn->title
  "Like ad-type-title, but from an ad-builder-urn, and aware of urns (like the
   Amazon STV one) that share an ad-type but should be titled differently."
  [urn]
  (if (= urn amazon-stv-ad-builder-urn)
    "Amazon STV"
    (ad-type-title (ad-builder-urn->ad-type urn))))

(defn get-main-component [components ad-type]
  (let [urn-list (:get-main-component (get ad-types (normalize-ad-type ad-type)))]
    ;; Find the first URN that exists in components
    (some (fn [urn] (get components urn)) urn-list)))

(defn get-variant-main-component [variant]
  (let [{:keys [components ad-type]} variant]
    (get-main-component components ad-type)))

(defn dimensions+duration
  [{{:keys [width height duration]} :dimensions ad-type :ad-type}]
  (let [component-type (or (get-component-type ad-type) :video)
        video? (= :video component-type)]
    (->> (cond-> []
           (and width height)
           (conj (str width "x" height))

           (and video? duration)
           (conj (template-duration-renderer duration)))
         (str/join " / "))))

(defn template-info [{:keys [ad-type components] :as ad-variant}]
  (let [title (if (or (= ad-type "vast-aws-prime")
                      (contains? components amazon-stv-component-key))
                "STV"
                (ad-type-title ad-type))
        dimensions+duration (dimensions+duration ad-variant)]
    (str/join " · " (cond-> [title]
                      (seq dimensions+duration) (conj dimensions+duration)))))

(defn variants->selection [variants]
  (into #{} (map :uuid) variants))

(defn selection-count [selection]
  (count selection))

(defn subselection
  "Returns part of selection a that is also included is selection b."
  [a b]
  (set/intersection a b))

(defn has-product-selector?
  "Checks if any ad variant in the given vector has a product-selector-id.
   Returns true if at least one ad variant has a product-selector-id, false otherwise."
  [ad-variants]
  (boolean
   (some (fn [variant]
           (some->> variant
                    :components
                    :urn:lemonpi:artefact:display:content+template
                    :value
                    :dynamic-content-config
                    vals
                    (filter #(= "products" (str (:source-type %))))
                    (map :config)
                    (some :product-selector-id)))
         ad-variants)))

(defn- get-product-config [dynamic-content]
  (->> dynamic-content
       vals
       (filter #(= "products" (:source-type %)))
       first
       :config))

(defn get-product-selector-id [variant]
  (-> variant get-variant-main-component :value :dynamic-content-config get-product-config :product-selector-id))

(defn variant-successfully-rendered?
  "Check if variant has successfully rendered.
   Returns false for queued/rendering/error states."
  [variant]
  (contains? #{"draft" "approved" "rejected" "internal-review" "archived"}
             (:ad-variant-status variant)))

(defn uuid-to-fake-score
  "Generate deterministic fake score (70-95) from UUID string.
   Same UUID always produces the same score."
  [uuid]
  (let [hash (reduce + (map int uuid))
        score-range 26 ; 95 - 70 + 1
        normalized (mod hash score-range)]
    (+ 70 normalized)))

(defn get-create-lift-data
  "Extracts the create-lift data from a variant's components.
   Returns a map with :state and :data keys, or nil if not available."
  [variant]
  (some-> variant
          :components
          (get-main-component (:ad-type variant))
          :metadata
          :export
          :createlift))

(defn get-create-lift-score
  "Extracts the create-lift score from a variant's components.
   Returns fake score (70-95) if variant is rendered but has no real score.
   Returns nil for variants that haven't rendered successfully."
  [variant]
  (when (variant-successfully-rendered? variant)
    (or (some-> (get-create-lift-data variant)
                :data
                :score)
        (uuid-to-fake-score (:uuid variant)))))
